import React from 'react';
import { MapPinIcon, PackageIcon, ArrowRightIcon } from 'lucide-react';
export function WarehouseCard({
  id,
  name,
  location,
  country,
  flag,
  stock,
  machines,
  onViewDetails
}) {
  // Determine color based on stock value
  const stockValue = parseInt(stock);
  const stockStatus = stockValue <= 0 ? 'empty' : stockValue < 50 ? 'low' : 'good';
  const statusConfig = {
    empty: {
      bg: 'bg-red-100',
      text: 'text-red-700',
      dot: 'bg-red-500',
      label: 'Sin stock'
    },
    low: {
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      dot: 'bg-amber-500',
      label: 'Stock bajo'
    },
    good: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-700',
      dot: 'bg-emerald-500',
      label: 'Stock óptimo'
    }
  };
  const config = statusConfig[stockStatus];
  return <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-blue-300 transition-all hover:shadow-lg" data-id="element-6253">
      {/* Top banner with ID and flag */}
      <div className="flex justify-between items-center px-4 py-2 bg-gray-50 border-b border-gray-200" data-id="element-6254">
        <div className="flex items-center" data-id="element-6255">
          <span className={`h-6 w-6 flex items-center justify-center rounded-md font-bold text-xs ${config.bg} ${config.text}`} data-id="element-6256">
            {id}
          </span>
        </div>
        <span className="text-xl" data-id="element-6257">{flag}</span>
      </div>
      {/* Main content */}
      <div className="p-4" data-id="element-6258">
        <h3 className="font-bold text-lg mb-2 line-clamp-1" data-id="element-6259">{name}</h3>
        <div className="flex items-start text-gray-500 text-sm mb-4" data-id="element-6260">
          <MapPinIcon size={14} className="mr-1 mt-0.5 flex-shrink-0" data-id="element-6261" />
          <p className="line-clamp-2" data-id="element-6262">{location}</p>
        </div>
        {/* Stats section */}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-6263">
          {/* Stock indicator */}
          <div className="flex flex-col" data-id="element-6264">
            <div className="flex items-center gap-2 mb-1" data-id="element-6265">
              <span className={`h-2.5 w-2.5 rounded-full ${config.dot}`} data-id="element-6266"></span>
              <span className="text-sm font-medium" data-id="element-6267">{config.label}</span>
            </div>
            <div className="text-2xl font-bold" data-id="element-6268">{stock}</div>
          </div>
          {/* Machine count */}
          <div className="flex flex-col items-end" data-id="element-6269">
            <span className="text-sm text-gray-500 mb-1" data-id="element-6270">Máquinas</span>
            <div className="flex items-center" data-id="element-6271">
              <div className={`flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 mr-2`} data-id="element-6272">
                <PackageIcon size={16} className="text-blue-600" data-id="element-6273" />
              </div>
              <span className="text-xl font-bold" data-id="element-6274">{machines}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Action button */}
      <div className="border-t border-gray-100" data-id="element-6275">
        <button onClick={onViewDetails} className="w-full flex items-center justify-center gap-1 py-3 text-blue-600 hover:bg-blue-50 transition-colors font-medium" data-id="element-6276">
          Ver detalles
          <ArrowRightIcon size={16} data-id="element-6277" />
        </button>
      </div>
    </div>;
}